// Mobile Configuration File
// This file controls the mobile overlay functionality
// Change MOBILE_FUNCTIONALITY_ENABLED to true when mobile optimization is complete

export const MOBILE_FUNCTIONALITY_ENABLED = false; // Set to true when mobile is ready

export const MOBILE_OVERLAY_CONFIG = {
    // Feature flag - controls whether mobile overlay is shown
    showOverlay: !MOBILE_FUNCTIONALITY_ENABLED,
    
    // Screen size breakpoints
    mobileBreakpoint: 768,
    smallMobileBreakpoint: 480,
    
    // Detection settings
    enableTouchDetection: true,
    enableUserAgentDetection: true,
    
    // Storage keys
    dismissalStorageKey: 'garden_planner_mobile_dismissed',
    sessionStorageKey: 'garden_planner_mobile_session_dismissed',
    
    // Overlay behavior
    allowTryAnyway: false,
    allowPermanentDismissal: true,
    
    // Tablet support (tablets are considered desktop-class)
    tabletsAllowed: true,
    
    // Debug mode
    debugMode: false
};

// Quick enable/disable functions for developers
export function enableMobileFunctionality() {
    console.log('🔧 Mobile functionality enabled via config');
    // You can add additional logic here when enabling mobile
    return true;
}

export function disableMobileFunctionality() {
    console.log('🔧 Mobile functionality disabled via config');
    // You can add additional logic here when disabling mobile
    return false;
}

// Version info for tracking
export const MOBILE_CONFIG_VERSION = '1.0.0';

// Instructions for future developers
export const INSTRUCTIONS = {
    toEnableMobile: [
        '1. Set MOBILE_FUNCTIONALITY_ENABLED = true in this file',
        '2. Test on various mobile devices',
        '3. Verify all functionality works properly',
        '4. Deploy the updated configuration'
    ],
    toDisableMobile: [
        '1. Set MOBILE_FUNCTIONALITY_ENABLED = false in this file',
        '2. The overlay will automatically appear for mobile users',
        '3. Desktop and tablet users will not be affected'
    ],
    testing: [
        '1. Use browser dev tools to simulate mobile devices',
        '2. Check console for mobile detection logs',
        '3. Test overlay dismissal and re-appearance',
        '4. Verify localStorage/sessionStorage behavior'
    ]
}; 